<ng-template #selectAll let-selectOptions="selectOptions">
  <mat-option (click)="toggleSelectAll(selectOptions)">
    <mat-pseudo-checkbox
      class="mat-option-pseudo-checkbox"
      [state]="getSelectAllState(selectOptions)"
    >
    </mat-pseudo-checkbox>
    {{ props.selectAllOption }}
  </mat-option>
</ng-template>
<mat-select
  #select
  [id]="id"
  [attr.data-test]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [placeholder]="props.placeholder || ''"
  [tabIndex]="props.tabindex"
  [required]="required"
  [compareWith]="$any(props.compareWith)"
  [multiple]="props.multiple"
  (selectionChange)="change($event)"
  [errorStateMatcher]="errorStateMatcher"
  [aria-label]="_getAriaLabel()"
  [aria-labelledby]="_getAriaLabelledby()"
  [disableOptionCentering]="props.disableOptionCentering"
  [typeaheadDebounceInterval]="props.typeaheadDebounceInterval"
>
  <ng-container *ngrxLet="props.options as options">
    <ng-container
      *ngIf="
        options
          | formlySelectOptions : field
          | async
          | laSelectOptionWithMeta : options as selectOptions
      "
    >
      <ng-container
        *ngIf="props.multiple && props.selectAllOption"
        [ngTemplateOutlet]="selectAll"
        [ngTemplateOutletContext]="{ selectOptions: selectOptions }"
      >
      </ng-container>
      <ng-container *ngFor="let item of selectOptions">
        <mat-optgroup *ngIf="item.group" [label]="item.label">
          <mat-option
            *ngFor="let child of item.group"
            [value]="child.value"
            [disabled]="child.disabled"
          >
            {{ child.label }}
          </mat-option>
        </mat-optgroup>
        <mat-option
          *ngIf="!item.group && item.value !== -1"
          [value]="item.value"
          [disabled]="item.disabled"
          [attr.data-test]="item.value"
        >
          <div class="hstack gap-1">
            <lui-avatar
              *ngIf="item.meta && props.showOptionIcons"
              [color]="item.meta.color || 'grayMedium'"
              [size]="32"
            >
              <mat-icon [svgIcon]="item.meta.icon || 'help'"></mat-icon>
            </lui-avatar>
            <span>
              {{ item.label }}
            </span>
          </div>
        </mat-option>
        <mat-option
          *ngIf="!item.group && item.value === -1"
          [value]="item.value"
          [disabled]="item.disabled"
        >
          <mat-icon svgIcon="add"></mat-icon>
          {{ item.label }}</mat-option
        >
      </ng-container>
    </ng-container>
  </ng-container>
</mat-select>
